import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const Period: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { periods } = useDictionaries(['periods']);

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={periods}
      withCrossIcon={false}
    />
  );
};
